// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d9c81648","455":"75ba8416","488":"8afebaf3"}[chunkId] + ".chunk.js";
};